import React from "react";
import { Card } from "react-bootstrap";
 
const FeedbackMaestro = () => {
    return (
		<>
            <Card>
                <Card.Header>Feedback</Card.Header>
                <Card.Body>
                    <div className="m-5 text-center">Coming soon</div>
                </Card.Body>
            </Card>
        </>
	)
}
export default FeedbackMaestro;
